import React, { useEffect, useRef, useState } from 'react';
import { helpHttp } from '../../helpers/helpHttp';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { BASE_API, LABELTEXT } from '../../api/Globals';
import { InputText } from 'primereact/inputtext';
import { FileUpload } from 'primereact/fileupload';
import { FilterMatchMode } from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';
import Menu from '../../components/sturtural/Menu';
import FolioTablet from '../../components/dialogs/FolioTablet';
import * as XLSX from 'xlsx';
import FolioConsulta from '../../components/dialogs/FolioConsulta';
// import Scanner from '../entrega/barcode';
import { Dropdown } from 'primereact/dropdown';
import { ScrollPanel } from 'primereact/scrollpanel';
import RegistrarTableta from '../../components/dialogs/RegistroTableta';
import { storage } from '../../helpers/storage';

const filtroOptions = [
    { label: 'Entradas almacén', value: 'E' },
    { label: 'Registros', value: 'C' },
    { label: 'En almacén', value: 'A' },
    { label: 'Devoluciones', value: 'R' }
];

const filtroOptionsAlt = [
    { label: 'En Almacén', value: 'E' },
    { label: 'Devoluciones', value: 'R' }
];


const AltaTablets = () => {
    const [tablets, setTablets] = useState(null);
    const [tabletDialog, setTabletDialog] = useState(false);
    const [mensajeEjecucion, setMensajeEjecucion] = useState(null);
    const [mensajeDialog, setMensajeDialog] = useState(false)
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
    const [layout, setLayout] = useState([])
    const [folioData, setFolioData] = useState([])
    const [dataConsulta, setDataConsulta] = useState([])
    const toast = useRef(null)
    const idPerfil = storage.get('perfilid')

    const [filtro, setFiltro] = useState(idPerfil !== "16" ? filtroOptions[0].value : filtroOptionsAlt[0].value)
    const [displayFolioConsulta, setDisplayFolioConsulta] = useState(false);
    const [displayFolioTablet, setDisplayFolioTablet] = useState(false);
    const [displayDialogExcel, setDisplayDialogExcel] = useState(false);

    const [loadingTabla, setLoadingTabla] = useState(false);
    const [loading1, setLoading1] = useState(false)

    useEffect(() => {
        if (tablets === null) {
            ListarTablets();
        }
    }, [tablets]);

    useEffect(() => {
        ListarTablets()
    }, [filtro])

    async function ListarTablets() {
        setLoadingTabla(true)
        const url = (`${BASE_API}Tablets/postSpdAlmObtenerlistadoTabletsFolioMov`)
        const resTablets = await helpHttp().post(url, {
            body: {
                idUsuario: storage.get('id'),
                idEstatus: 2,
                idTienda: storage.get('IdTienda'),
                idAlmacen: null,
                parametrosExtra: filtro
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            setLoadingTabla(false)
            return res.ITEMS;
        })

        setTablets(resTablets)
        // console.log(resTablets)
    }

    const hideDialog = () => {
        setTabletDialog(false);
        setTablets(null)
    }
    const openNew = () => {
        setTabletDialog(true)
    }

    const uploadHandler = async (e) => {
        const reader = new FileReader();
        reader.readAsBinaryString(e.files[0]);
        reader.onload = (e) => {
            const data = e.target.result;
            const workbook = XLSX.read(data, { type: "binary" });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const pharseData = XLSX.utils.sheet_to_json(sheet);

            setLayout(pharseData)
            setDisplayDialogExcel(true)
        }
    }

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Registrar" icon="pi pi-plus" className="p-button mr-3" onClick={openNew} />
                {layout.length === 0 && <FileUpload name='demo[]' url='/api/upload' mode='basic' auto accept='.xls, .xlsx' maxFileSize={1000000}
                    uploadHandler={uploadHandler} chooseLabel='Cargar excel' customUpload={true} />}
            </React.Fragment>
        )
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className='flex-column gap-2'>
                    <label htmlFor='filtro'>Estatus:</label>
                    <Dropdown id='filtro' value={filtro} options={idPerfil !== "16" ? filtroOptions : filtroOptionsAlt} onChange={e => setFiltro(e.value)} style={{ marginLeft: '20px' }}/>
                </div>
            </React.Fragment>
        )
    }

    const icon = (rowData) => {
        // console.log(rowData.IdEstatus)
        return <Button icon='pi pi-ellipsis-h' rounded text onClick={() => {
            if (!([2, 3].includes(rowData.IdEstatus))) {
                setFolioData(rowData);
                setDisplayFolioTablet(true)
            } else {
                setDataConsulta(rowData)
                setDisplayFolioConsulta(true)
            }
        }} />
    }

    const semaforoTemplate = (option) => {

        return (
            <>
                <Tooltip target=".custom-target-label" />
                <i className="pi pi-circle-fill custom-target-label" data-pr-tooltip={option.Estatus} style={{ color: option.indicador }}></i>
            </>
        )
    }

    const formatHeader = () => {
        switch (filtro) {
            case 'E':
                return 'para recibir';
            case 'A':
                return 'en almacén';
            case 'R':
                return 'devueltos';
        }
    }

    const importarExcel = () => {
        if (layout.length > 0) {
            setLoading1(true)
            const Tabla = layout.map(e => {
                let item = {
                    codigoPrenda: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? e.Serie.toString().slice(0, 2) : "09",
                    codigoTalla: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? e.Serie.toString().slice(2, 5) : "111",
                    serie: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? e.Serie.toString().slice(5) : e.Serie.toString()
                }
                return item
            })
            const url = (`${BASE_API}Tablets/postspdAlmAltaTablet`)
            helpHttp().post(url, {
                body: {
                    opcion: "D",
                    listaTablets: Tabla,
                    tipo: parseInt(process.env.REACT_APP_SISTEMA) === 1 ? "Uniformes" : "Tablets",
                    idEstatus: storage.get('perfilid') === 1 ? 1 : 2,
                    idUsuario: storage.get('id'),
                    NotificaciondeEjecucion: ""
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                // console.log(res)
                if (res.SUCCESS !== false) {
                    // toast.current.show({ severity: 'success', summary: 'Movimineto realizado', detail: 'Tabletas registradas', life: 5000 });
                    // setTablets(null)
                    // onHideExcel()
                    setMensajeEjecucion(JSON.parse(res.ITEMS.NotificacionEjecucion))
                    // console.log(JSON.parse(res.ITEMS.NotificacionEjecucion))
                    setMensajeDialog(true)
                } else {
                    toast.current.show({ severity: 'warn', summary: 'Aviso', detail: 'Hubo un problema', life: 5000 });
                }
                setLoading1(false)
            })
        }
    }

    const formatHeaderAlt = () => {
        switch (filtro) {
            case 'E':
                return 'en almacén';
            case 'R':
                return 'devueltos';
        }
    }

    const DateFormatTemplate = (options) => {
        const date = new Date(options.Fecha)

        return <div className='text-center'><label>{date.toLocaleDateString('em-GB')}</label></div>
    }

    const footerExcelTemplate = () => {
        return (
            <React.Fragment>
                <Button icon='pi pi-times' className='p-button-outlined' loading={loading1} label='Cancelar' onClick={onHideExcel} />
                <Button icon='pi pi-check' className='p-button' label='Guardar' disabled={loading1} onClick={() => importarExcel()} />
            </React.Fragment>
        )
    }

    const onHideExcel = () => {
        setLayout([]);
        setDisplayDialogExcel(!displayDialogExcel);
    }

    return (
        <>
            <Toast ref={toast} />
            <Menu link='filtro' />
            <div className='grid card'>
                <div >
                    <h3 style={{ textAlign: 'center'}}>{idPerfil == "16" ? 'GESTIÓN DE ALMACÉN' : 'GESTIÓN DE ENTRADAS'}</h3>
                </div>
                <div className='col-12'>
                    <Toolbar right={idPerfil !== "16" ? rightToolbarTemplate : null} left={leftToolbarTemplate} />
                </div>
                <div className='col-12 mt-3'>
                    {/* <h3>Folios {window.localStorage.getItem('perfilid') !== '16' ? formatHeader() : formatHeaderAlt()}</h3> */}
                    <DataTable value={tablets} showGridlines loading={loadingTabla}
                        filters={filters} globalFilterFields={['FolioTransferencia', 'TIenda_Destino']}
                        paginator rows={20} paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="Mostrando del {first} al {last} de {totalRecords} folios."
                        emptyMessage="Sin folios.">
                        <Column field='indicador' header='Indicador' body={semaforoTemplate} alignHeader={'center'} bodyStyle={{ textAlign: 'center' }} />
                        <Column field='FolioTransferencia' header='Folio' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                        {storage.get('perfilid') !== '16' ? <Column field='TIenda_Destino' header='Destino' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} /> : <Column field="Tienda_Origen" header="Destino origen" bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />}
                        <Column field='Estatus' header='Estatus' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                        <Column field='totalTablet' header={`Total de ${LABELTEXT.toLocaleLowerCase()}`} bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                        {filtro === 'R' && <Column field='Observaciones' header='Observaciones' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />}
                        <Column field='Fecha' body={DateFormatTemplate} header='Fecha último registro' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                        <Column header='Detalle' body={icon} bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                    </DataTable>
                    <h5>Total de folios: {tablets !== null ? tablets.length : 0}</h5>
                </div>
            </div>

            <Dialog visible={mensajeDialog} onHide={() => setMensajeDialog(!mensajeDialog)} closable={false} draggable={false} breakpoints={{ '960px': '75vw', '641px': '100vw' }} style={{ width: '50%' }} modal header='AVISO' className="p-fluid"
                footer={<React.Fragment>
                    <Button label='Aceptar' className='p-button' onClick={() => { setMensajeDialog(!mensajeDialog); onHideExcel() }} />
                </React.Fragment>}>
                {mensajeEjecucion !== null &&
                    <div className='grid m-5'>
                        <div className='col-12'>
                            <h4> <span>{`Se han registrado ${mensajeEjecucion.totalRegistradas} ${LABELTEXT.toLowerCase()} correctamente.`}</span></h4>
                        </div>

                        {mensajeEjecucion.totalExistentes > 0 &&
                            <>
                                <div className='col-12'>
                                    <h6>{`${LABELTEXT} que ya estaban en existencia:`}</h6>
                                    <ScrollPanel style={{ height: '250px' }} className='custombar1' >
                                        <ul style={{ fontWeight: 'bold' }}>
                                            {mensajeEjecucion !== " " && mensajeEjecucion.Existentes.map(item => (<li>{item.Prenda} Talla: {item.Talla} Serie: {item.codigoPrenda + item.codigoTalla + item.Serie}</li>))}
                                        </ul>
                                    </ScrollPanel>
                                </div>
                                <div className='col-12 font-bold'>
                                    <span>Total de {`${LABELTEXT.toLowerCase()} en existencia: ${mensajeEjecucion.totalExistentes}`}</span>
                                </div>
                            </>
                        }
                    </div>
                }
            </Dialog>

            <Dialog visible={displayDialogExcel} header="IMPORTACIÓN DE EXCEL" draggable={false} onHide={onHideExcel} footer={footerExcelTemplate} style={{ width: '35%' }}>
                <div className='m-3'>
                    <DataTable value={layout} showGridlines
                        paginator rows={5} paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="Mostrando {first} al {last} de {totalRecords} registros.">
                        <Column field='Descripcion' header='Descripcion' alignHeader={'center'} style={{ textAlign: 'center' }} />
                        {/* <Column field='Talla' header='Talla' alignHeader={'center'} style={{ textAlign: 'center' }} /> */}
                        <Column field='Serie' header='Serie' alignHeader={'center'} style={{ textAlign: 'center' }} />
                    </DataTable>
                </div>
            </Dialog>

            <FolioTablet visible={displayFolioTablet} rowData={folioData} onHide={() => { setFolioData([]); setTablets(null); setDisplayFolioTablet(!displayFolioTablet) }} abreAlta={() => { setTabletDialog(true) }} />
            <FolioConsulta visible={displayFolioConsulta} rowData={dataConsulta} onHide={() => { setDataConsulta([]); setTablets(null); setDisplayFolioConsulta(!displayFolioConsulta) }} />
            <RegistrarTableta visible={tabletDialog} onHide={hideDialog} />
        </>
    );
}

export default AltaTablets;